module.exports = __webpack_public_path__ + "7654674dd8ae7e754f7450a74865c4fc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/slider/chat-black.svg
// module id = 1314
// module chunks = 61